export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-brush/src/constant.js
// module id = 1643
// module chunks = 3